import axios from "axios";
import { Message } from 'element-ui';

let http = axios.create({
  baseURL: "/api",
  // baseURL: "https://qrf-alloy.com/api",
  timeout: 40000,
});
// 请求拦截器
http.interceptors.request.use(
  (config) => {
    config.headers["lang-type"] = window.localStorage.getItem("selLanguage")?window.localStorage.getItem("selLanguage"):'1';
    return config;
  },
  (err) => {
    Message({
      message: "网络错误",
      type: "warning",
    });
  }
);

// 响应拦截器
http.interceptors.response.use(
  (Response) => {
    if (Response.data.code === -1) {
      return Response.data;
    } else if (Response.data.code === 400) {
      Message({
        message: Response.data.message,
        type: "warning",
      });
      return Response.data;
    } else if (Response.data.code) {
      return Response.data;
    }
  },
  (error) => {
    console.error(error, "error");
  }
);

// post请求
const post = (url, data) => http.post(url, data);
const get = (url, data) => http.get(url, {
  params:{...data}
});
const baseURL = "https://qrf-alloy.com"; //没有引用
export default { post, get, baseURL };
